// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1y4CO","buttons":"styles_buttons__2zzXe"};